import './app.scss';

import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";

import Navbar from './components/navbar/navbar';
import Home from "./pages/home/home";

export default function Router() {
    return (
        <BrowserRouter>
            <Navbar/>
            <main id="App">
                <Routes>
                    <Route path='/' element={ <Home/> }/>
                </Routes>
            </main>
        </BrowserRouter>
    );
};